import { render, staticRenderFns } from "./ExperimentalFeaturesModal.vue?vue&type=template&id=6db5df3b&scoped=true&"
import script from "./ExperimentalFeaturesModal.vue?vue&type=script&lang=js&"
export * from "./ExperimentalFeaturesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5df3b",
  null
  
)

export default component.exports